import { isToday } from 'date-fns'
import type { PreferredHourCycle } from '@shared/ipc/routers/BaseIpc.router'
import { formatUserTime } from '../../utils/user-time-format'

const monthDayFormatter = new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric' })
const weekdayMonthDayFormatter = new Intl.DateTimeFormat(undefined, {
  weekday: 'short',
  month: 'short',
  day: 'numeric',
})

/**
 * Formats a Date for display in the DateField header.
 * Returns "Today" if the date is today, otherwise a locale-aware short date (e.g. "Apr 8" or "8 Apr").
 */
export function formatDateField(date: Date): string {
  if (isToday(date)) return 'Today'
  return monthDayFormatter.format(date)
}

/**
 * Formats a Date as a preset subtitle using the client's locale.
 * e.g. "Today · 5:45 PM" or "Sat, Apr 11 · 9:00 AM" (format follows browser locale).
 */
export function formatPresetSubtitle(date: Date, hourCycle: PreferredHourCycle | null = null): string {
  const datePart = isToday(date) ? 'Today' : weekdayMonthDayFormatter.format(date)
  const timePart = formatUserTime(date, hourCycle)
  return `${datePart} · ${timePart}`
}
